module.exports = __webpack_public_path__ + "img/hero-poster.dddca0d.jpg";